import { createSelector } from 'reselect';
import { attachment as attachmentModel } from '../../../common/api/models';

const videoAttachmentsSelector = (state) => state.videoAttachments;

/**
 * @param {*} state
 * @return {array} attachments
 */
export const getVideoAttachmentsSelector = createSelector(videoAttachmentsSelector, (videoAttachments) =>
  videoAttachments.attachments ? videoAttachments.attachments.map((item) => attachmentModel(item)) : []
);

/**
 * @param {*} state
 * @return {bool} true || false
 */
export const getVideoAttachmentsAvailableSelector = createSelector(videoAttachmentsSelector, (videoAttachments) =>
  videoAttachments.attachments.length > 0 ? true : false
);

/**
 * @param {*} state
 * @return {number} total || null
 */
export const getVideoAttachmentsTotalNumberSelector = createSelector(videoAttachmentsSelector, (videoAttachments) =>
  videoAttachments.total > 0 ? videoAttachments.total : null
);
